import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/businessCategory/importer/businessCategoryImporterActions'

export default importerReducers(actions)
